<template>
<div  id="themePreview" :style="'--fontFamily: ' + fontFamilyValue">
  <v-card v-if="company" :style="[customBackground, textDirection]">
   <v-layout class="pt-3" v-if="company.logo_url && company.custom_properties.use_logo_as_header_bg" row wrap>
      <v-flex xs12 class="px-3">
        <v-img  width="100%" :src="company.logo_url" />
      </v-flex>
    </v-layout>
    <v-toolbar tabs flat :style="[customBackground, customPrimary__text]">
      <template v-if="!company.custom_properties.use_logo_as_header_bg">
        <v-layout v-if="company.logo_url" align-center class="mt-2">
          <v-card width="80px" height="80px" flat style="background: none">
            <v-img
              v-if="company.logo_url"
              width="80%"
              height="100%"
              class="cursor-pointer mt-3"
              contain
              :src="company.logo_url"
            ></v-img>
          </v-card>
        </v-layout>
        <div
          v-else
          :style="[customPrimary__text]"
          class="title font-weight-bold cursor-pointer"
        >
          {{ company.title }}
        </div>
      </template>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat :style="[customPrimary__text]">{{$t('company.theme.preview.my_account')}}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text class="mt-5">
      <div class="headline mb-3 ml-2">
        <span :style="[customPrimary__text]"
          >{{$t('company.theme.preview.on_going_events')}}</span
        >
      </div>
      <v-layout row wrap>
        <v-layout wrap row>
          <v-flex v-for="n in 4" :key="n" xs3 md3>
            <v-card
              class="mx-2"
              max-height="210"
              max-width="180"
              :dark="darkMode"
            >
              <v-img src="../../assets/no-image.svg" width="100%"></v-img>
              <div class="ml-2 pb-2">
                <div :style="[customSecondary__text]">
                  {{ moment().format("lll") }}
                </div>
                <div :style="[customSecondary__text]">Event {{ n }}</div>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
      <div class="text-xs-center">
        <v-btn
          class="mt-4 mb-4"
          :style="[customBackground__text, customPrimary]"
          >{{$t('company.theme.preview.see_more_events')}}</v-btn
        >
      </div>
    </v-card-text>
    <v-card-text>
      <div class="headline mb-3 ml-2">
        <span :style="[customPrimary__text]"
          >{{$t('company.theme.preview.upcoming_events')}}</span
        >
      </div>
      <v-layout row wrap>
        <v-layout wrap row>
          <v-flex v-for="n in 4" :key="n" xs3 md3>
            <v-card
              class="mx-2"
              max-height="210"
              max-width="180"
              :dark="darkMode"
            >
              <v-img src="../../assets/no-image.svg" width="100%"></v-img>
              <div class="ml-2 pb-2">
                <div :style="[customSecondary__text]">
                  {{ moment().format("lll") }}
                </div>
                <div :style="[customSecondary__text]">Event {{ n }}</div>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
      <div class="text-xs-center">
        <v-btn
          class="mt-4 mb-4"
          :style="[customBackground__text, customPrimary]"
          >{{$t('company.theme.preview.see_more_events')}}
          </v-btn>
      </div>
    </v-card-text>
    <v-footer height="auto" :dark="darkMode">
      <v-layout justify-center row wrap>
        <v-flex py-3 text-xs-center secondary--text xs12>
          <div class="pb-2">
            <template v-for="(menu, i) in footer_menus">
              <a
                :style="[customSecondary__text]"
                class="ml-2"
                :key="i + menu.slug"
                >{{ menu.text }}</a
              >
            </template>
          </div>
          <div :style="[customSecondary__text]">
            <div v-if="company.show_company_branding && company.custom_properties.powered_by_message">
              {{company.custom_properties.powered_by_message}}
            </div>
            <div v-else>
              &copy;{{ moment().format("YYYY") }} — Powered By
              <a target="_blank" class="text-decoration-none">
                <strong :style="[customPrimary__text]">Communicada</strong>
              </a>
           </div>
          </div>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-card>
</div>
</template>

<script>
import DEFINES from '@/defines';
export default {
  name: "CompanyThemePreview",
  props: {
    company: {
      type: Object,
      default: null,
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
    fontFamily: {
      type: Object,
      default: DEFINES.DEFAULT_FONTS,
    },
  },
  data() {
    return {
      footer_menus: [
        {
          slug: "about",
          text: "About",
        },
        {
          slug: "privacy",
          text: "Privacy",
        },
        {
          slug: "terms",
          text: "terms",
        },
      ],
      fontFamilyValue: this.fontFamily.value,
      fontFamilyUrl: this.fontFamily.url,
    }
  },
  computed: {
    customPrimary__text() {
      return { color: this.company.custom_properties.theme.primaryColor };
    },
    customPrimary() {
      return {
        backgroundColor: this.company.custom_properties.theme.primaryColor,
      };
    },
    customSecondary__text() {
      return { color: this.company.custom_properties.theme.secondaryColor };
    },
    customSecondary() {
      return {
        backgroundColor: this.company.custom_properties.theme.secondaryColor,
      };
    },
    customBackground__text() {
      return { color: this.company.custom_properties.theme.backgroundColor };
    },
    customBackground() {
      return {
        backgroundColor: this.company.custom_properties.theme.backgroundColor,
      };
    },
    textDirection() {
      return {
        direction: this.company.custom_properties.is_rtl ? "rtl" : "ltr",
      };
    },
  },
  watch: {
    fontFamily: {
      deep: true,
      handler: function(newVal, oldVal) {
        this.fontFamilyUrl = newVal.url;
        this.fontFamilyValue = newVal.value
        this.loadFontFace();
      },
    },
  },
  mounted(){
    this.loadFontFace();
  },
  methods:{
    loadFontFace(){
      var _this = this;
      var junction_font = new FontFace(this.fontFamilyValue, `url(${this.fontFamilyUrl})`);
        junction_font.load().then(function(loaded_face) {
          document.fonts.add(loaded_face);
            document.body.style.fontFamily = _this.fontFamilyValue;
        }).catch(function(error) {
      });
    }
  }

};
</script>
<style >
#themePreview {
    font-family: var(--fontFamily) !important;
}
#themePreview .headline{
    font-family: var(--fontFamily) !important;
}
</style>
